import { css } from '@emotion/css'
import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import {
  AgentFeature,
  isFeatureEnabledForLanguage
} from '../../../../components/agent-features'
import { AssessGradeBadge } from '../../../../components/badge'
import { LibraryAgentLanguage } from '../library/library-agent-language'
import { Grade } from '../../helpers/ui-interfaces'
import {
  Tooltip,
  TooltipProps
} from '@contrast-security-inc/design-system-popovers'

export function GradeCell({
  features,
  tooltipPlacement,
  rowData: {
    language,
    grade: { value }
  }
}: {
  readonly features: AgentFeature[]
  readonly tooltipPlacement?: TooltipProps['placement']
  readonly rowData: {
    readonly language: LibraryAgentLanguage
    readonly grade: Grade
  }
}) {
  const isAssessSupported =
    features &&
    isFeatureEnabledForLanguage({
      language: LibraryAgentLanguage.fromLibraryAgentLanguage(language),
      agentFeatures: features,
      featureName: 'assess'
    })
  return (
    <Tooltip placement={tooltipPlacement} body={<TooltipContent />}>
      <div>
        <AssessGradeBadge value={value} isAssessSupported={isAssessSupported} />
      </div>
    </Tooltip>
  )
}

export function TooltipContent() {
  const intl = useIntl()

  return (
    <div
      className={css`
        padding: 8px;
        max-width: 225px;
      `}
    >
      <FormattedMessage
        id="detail_libraryGrade_gradeLetterDescription_withLink"
        values={{
          link: (
            <FormattedMessage
              id="action_learnMore"
              children={(learnMoreMsg) => {
                return (
                  <a
                    rel="noreferrer"
                    target="_support"
                    href={intl.formatMessage({
                      id: 'link_libraryScoringGuide'
                    })}
                  >
                    {learnMoreMsg}
                  </a>
                )
              }}
            />
          )
        }}
      />
    </div>
  )
}
